export default __webpack_public_path__ + "static/media/reckless-light-webfont.65013490.woff2";